// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__ZlhJY","loader":"Loader_loader__UPBRT","loader_animation":"Loader_loader_animation__LWOG+"};